module.exports = __webpack_public_path__ + "static/media/zicht_tuin_2.0ee7c6e4.jpg";